import React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <p>
          <Link className="footer-link" to="/mentions">
            Mentions Légales
          </Link>
        </p>
        <p>
          <Link className="footer-link" to="/politiquedeconfidentialite">
            Politique de confidentialité
          </Link>
        </p>
        <p className="text-center">© Copyright 2025 VINCENT FERNANDEL PRODUCTION</p>
        <p>Images © VFP & D.R.</p>
      </div>
    </div>
  );
};

export default Footer;
